import Headroom from "headroom.js";

export default function Navigation() {

  let hasPastThreshold = false;

  let themedSections = Array.prototype.slice.call(document.querySelectorAll('[data-header-theme]'), 0)
  let themes = []

  themedSections.forEach((section) => {
    if (themes.indexOf(section.dataset.headerTheme) === -1) {
      themes.push(section.dataset.headerTheme)
    }
  })

  // Create custom events for Headroom.js to hook up header-based layout changes
  const stickyNavChangedEvent = document.createEvent('CustomEvent');
  stickyNavChangedEvent.initEvent('stickyNavChanged', true, true);

  function switchToDefaultNav() {
    if (!hasPastThreshold) {
      return false;
    }

    let nav = this.elem;

    let transitionEnd = function(e) {
      nav.classList.remove('header--sticky');
      nav.classList.remove('header--slide-up');
      window.dispatchEvent(stickyNavChangedEvent);
    };

    setTimeout(transitionEnd, 400);
    nav.classList.add('header--slide-up');
    document.body.classList.remove('has-sticky-nav');
  }

  function switchToStickyNav() {
    hasPastThreshold = true;

    let nav = this.elem;

    let transitionEnd = function(e) {
      nav.classList.add('header--sticky');
      document.body.classList.add('has-sticky-nav');
      nav.classList.remove('header--slide-up');
      window.dispatchEvent(stickyNavChangedEvent);
    };

    setTimeout(transitionEnd, 400);
    nav.classList.add('header--slide-up');
  }

  // Headroom
  const header = document.querySelector('.header');

  // Otherwise, init with options
  const headroom = new Headroom(header, {
    offset: 150,
    tolerance: 3,
    onTop: switchToDefaultNav,
    onNotTop: switchToStickyNav
  });

  headroom.init();


  let scrolled = false
  let sectionCount = themedSections.length
  function updateHeaderTheme() {

    if (scrolled) {
      let scrollY = typeof window.pageYOffset !== 'undefined' ? window.pageYOffset : window.scrollY;

      for (var i = 0; i < sectionCount; i++) {
        var currentSection = themedSections[i]
        var nextSection = themedSections[i + 1];

        if (typeof nextSection == 'undefined') {

          if (scrollY > currentSection.offsetTop) {
            themes.forEach((theme) => header.classList.remove(theme))
            header.classList.add(currentSection.dataset.headerTheme)            
          }

          break;
        }

        if (scrollY > currentSection.offsetTop && scrollY < nextSection.offsetTop) {
          // remove any existing themes
          themes.forEach((theme) => header.classList.remove(theme))
          header.classList.add(currentSection.dataset.headerTheme)
          break;
        }
      }

      scrolled = false
    }
    requestAnimationFrame(updateHeaderTheme)
  }

  requestAnimationFrame(updateHeaderTheme)

  window.addEventListener('scroll', () => {
    scrolled = true
  })
}
